export interface NavLink {
    title: string;
    href: string;
    
    submenu?: NavLink[];
}

export const navLinks: NavLink[] = [
    {
        title: "Home",
        href: "/",
    },
    {
        title: "About",
        href: "/about",
    },
    {
        title: "Courses",
        href: "/courses",
    },
    {
        title: "Events",
        href: "/events",
       
    },
    {
        title: "Contact",
        href: "/contact",
    },
    
];


export const mobileOnlyLinks: NavLink[] = [
  { title: "Enroll Now", href: "/enquiryPage" },
  { title: "Track Application", href: "/applicationTracker" },
];

